import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader, Section, Pill } from "@/components/ui-kit";

export default function PaymentsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/dashboard/global").then(({ data }) => setItems(data.recent_payments || [])).catch(() => {});
  }, []);
  return (
    <div data-testid="payments-page">
      <PageHeader title="Payments" subtitle="Global Admin · Stripe transactions" />
      <Section title="All recent transactions" testId="payments-list">
        {items.length === 0 ? (
          <div className="text-sm text-muted-foreground py-6 text-center">No transactions yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left">
              <th className="label py-2">Created</th><th className="label py-2">Session</th><th className="label py-2">Cycle</th>
              <th className="label py-2 text-right">Amount</th><th className="label py-2 text-right">Status</th>
            </tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-border">
                  <td className="py-2.5">{fmtDate(p.created_at)}</td>
                  <td className="py-2.5 font-mono text-xs">{p.session_id?.slice(0, 12)}…</td>
                  <td className="py-2.5 capitalize">{p.billing_cycle || "—"}</td>
                  <td className="py-2.5 text-right tabular-nums">{fmtMoney(p.amount, p.currency)}</td>
                  <td className="py-2.5 text-right"><Pill variant={p.status === "PAID" ? "success" : p.status === "FAILED" ? "warning" : "info"}>{p.status}</Pill></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Section>
    </div>
  );
}
